import { render, staticRenderFns } from "./SuggestionStepper.vue?vue&type=template&id=4b49e130&scoped=true"
import script from "./SuggestionStepper.vue?vue&type=script&lang=ts"
export * from "./SuggestionStepper.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionStepper.vue?vue&type=style&index=0&id=4b49e130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49e130",
  null
  
)

export default component.exports